export const GET_PLANVALUEOVERTIME_ABORTED = 'GET_PLANVALUEOVERTIME_ABORTED';
export const GET_PLANVALUEOVERTIME_REQUESTED =
  'GET_PLANVALUEOVERTIME_REQUESTED';
export const GET_PLANVALUEOVERTIME_COMPLETED =
  'GET_PLANVALUEOVERTIME_COMPLETED';
export const GET_PLANVALUEOVERTIME_FAILED = 'GET_PLANVALUEOVERTIME_FAILED';
